import script from "./CorporateDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./CorporateDropdown.vue?vue&type=script&setup=true&lang=js"

import "./CorporateDropdown.vue?vue&type=style&index=0&id=0479729e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0479729e"]])

export default __exports__